$(document).ready(function () {
    window.bvCallback = function (BV) {
        if (typeof BV !== 'undefined') {
            if (typeof BV.reviews !== 'undefined') {
                BV.reviews.on('show', function () {
                    // This line assumes SFRA collapsible panels and is called when clicking on the review summary
                    $('.row.reviews:not(.active)').toggleClass('active');
                });
            }
            if (typeof BV.questions !== 'undefined') {
                BV.questions.on('show', function () {
                    // This line assumes SFRA collapsible panels and is called when clicking on the Q&A summary
                    $('.row.questions:not(.active)').toggleClass('active');
                });
            }
        }
    };
    var getBVData = setInterval(function () {
        if (parseInt($('.product-collection-rating .bv_numReviews_text').eq(0).text().replace('(', '').replace(')', '')) === 0) { // eslint-disable-line
            $('.product-collection-rating .bv_ratings_summary').remove();
            $('.product-collection-rating .bv_war_button').text('Write the First Review');
            $('.product-detail .custom-bv-show').addClass('d-block');
            clearInterval(getBVData);
        } else if (parseInt($('.product-collection-rating .bv_numReviews_text').eq(0).text().replace('(', '').replace(')', '')) >= 1) { // eslint-disable-line
            $('.product-detail .custom-bv-show').addClass('d-block');
            $('.product-collection-rating .bv_war_button').attr('style', 'display: none !important');
            clearInterval(getBVData);
        }
    }, 1500);
});
